// extracted by mini-css-extract-plugin
export default {"codes":"K0_kNawh6hxxQKYrtmbx","footer":"giU9uJVg4BLhvOcNV9TB","buttonHolder":"edTtUYS9HngZNc2XaeQv","icon":"YGHqPlb1wwCjCavChNGp","listHolder":"NuZK9eg2Hz85Ky2XLOYo"};